import { render, staticRenderFns } from "./EnterOuterCelestialsModal.vue?vue&type=template&id=35630836&scoped=true&"
import script from "./EnterOuterCelestialsModal.vue?vue&type=script&lang=js&"
export * from "./EnterOuterCelestialsModal.vue?vue&type=script&lang=js&"
import style0 from "./EnterOuterCelestialsModal.vue?vue&type=style&index=0&id=35630836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35630836",
  null
  
)

export default component.exports